export default __webpack_public_path__ + "static/media/icon-jobs-light.e9f1f705.svg";